var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomerOutlineIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99697 1.05514C5.08565 1.05514 4.34688 1.79391 4.34688 2.70522C4.34688 3.61654 5.08565 4.35531 5.99697 4.35531C6.90829 4.35531 7.64706 3.61654 7.64706 2.70522C7.64706 1.79391 6.90829 1.05514 5.99697 1.05514ZM3.24683 2.70522C3.24683 1.18636 4.47811 -0.0449219 5.99697 -0.0449219C7.51584 -0.0449219 8.74712 1.18636 8.74712 2.70522C8.74712 4.22409 7.51584 5.45537 5.99697 5.45537C4.47811 5.45537 3.24683 4.22409 3.24683 2.70522Z",
    fill: "#4F4F4F",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79775 7.09811C2.88644 7.09811 2.14767 7.83687 2.14767 8.74819V11.4983C2.14767 11.8021 1.90141 12.0484 1.59764 12.0484C1.29386 12.0484 1.04761 11.8021 1.04761 11.4983V8.74819C1.04761 7.22933 2.27889 5.99805 3.79775 5.99805H8.19799C9.71685 5.99805 10.9481 7.22933 10.9481 8.74819V11.4983C10.9481 11.8021 10.7019 12.0484 10.3981 12.0484C10.0943 12.0484 9.84808 11.8021 9.84808 11.4983V8.74819C9.84808 7.83687 9.10931 7.09811 8.19799 7.09811H3.79775Z",
    fill: "#4F4F4F",
    stroke: "white",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerOutlineIcon);
export default __webpack_public_path__ + "static/media/CustomerOutlineIcon.0d7cbf03d14ab573988e9ebfef2f3221.svg";
export { ForwardRef as ReactComponent };